<template>
<div>
    <ValidationObserver v-slot="{ invalid }" ref="form_val">
        <el-form ref="forms" v-model="forms" label-position="left">
            <input type="hidden" v-model="id" v-if="isupd">
            <div class="modal-body">
                <div class="form-group">
                    <label>帳號 </label>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                        <span style="color:red;">{{ errors[0] }}</span>
                        <input type="text" class="form-control" ref="acc" v-model="acc" :disabled="isupd">
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label>密碼 </label>
                    <ValidationProvider rules="required" v-slot="{ errors }" v-if="!isupd">
                        <span style="color:red;">{{ errors[0] }}</span>
                        <input type="password" class="form-control" ref="pwd" v-model="pwd">
                    </ValidationProvider>
                    <input type="password" class="form-control" ref="pwd" v-model="pwd" v-if="isupd">
                </div>
                <div class="form-group">
                    <label>姓名 </label>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                        <span style="color:red;">{{ errors[0] }}</span>
                        <input type="text" class="form-control" ref="name" v-model="name">
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label>信箱 </label>
                    <ValidationProvider rules="required|email" v-slot="{ errors }">
                        <span style="color:red;">{{ errors[0] }}</span>
                        <input type="email" class="form-control" ref="email" v-model="email">
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label>公司 </label>
                    <select class="form-control" v-model="com">
                        <option v-for="c in coms" :value="c.id">{{c.name}}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>角色 </label>
                    <select class="form-control" v-model="role">
                        <option v-for="r in roles" :value="r.id">{{r.name}}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>狀態 </label>
                    <select class="form-control" v-model="status">
                        <option value="0" selected>啟用</option>
                        <option value="1">停用</option>
                    </select>
                </div>
            </div>
            <div class="modal-footer" style="justify-content:center">
                <button type="button" class="btn bg-navy" @click="close()">關閉</button>
                <button type="button" class="btn btn-warning" @click="reset()">清除</button>
                <button type="button" class="btn btn-primary" @click="send()" :disabled="invalid">送出</button> 
            </div>
        </el-form>
    </ValidationObserver>
</div>
</template>

<script>
import EventBus from '@b/../utils/event-bus.js'
import { extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import { apiGet, apiAdd, apiUpd } from "@b/api/admin.js";
import { apiGet as apiGetRoles } from "@b/api/admin_roles.js";
import { apiGet as apiGetCom } from "@b/api/com.js";

extend('required', {
    ...required,
    message: '欄位為必填'
});

extend('email', {
    ...email,
    message: '請填信箱格式'
});

export default {
    props: {
        meta: {}, 
    },
    data() {
        return {
            isupd: false,
            forms:{}, 
            id: '', pwd: '', acc: '', name: '', email: '',  status: 0,
            role: '', roles: [],
            com: '', coms: [],
            users: [],
        }
    },
    created() {
        if(this.meta){
            this.isupd= true
            this.getAdmin(this.meta)
        }
        this.getcom()
        this.getRoles()

    },
    computed: {        
        isComplete () {
            if(this.isupd){
                return this.acc && this.name && this.email;
            }else{
                return this.acc && this.pwd && this.name && this.email;
            }
        }
    },
    methods: {
        getdata(){
            let data = {
                password: this.pwd,
                name: this.name,
                email: this.email,
                role: this.role,
                status: this.status,
                com_id: this.com,
            }  

            if(this.isupd){
                data.id= this.id
            }else{
                data.account= this.acc
            }

            return data
        },
        getAdmin(query){
            let json = JSON.stringify([['id','=',query]])
            apiGet(json)
            .then(res => {
                this.setdata(res.data.data[0])
            })
            .catch(err => {
                console.log(err)
            });
        },
        getcom(){
            apiGetCom('')
            .then(res => {
                this.coms = res.data.data
            })
            .catch(err => {
                console.log(err)
            });
        },
        getRoles(){
            apiGetRoles('')
            .then(res => {
                this.roles = res.data.data
            })
            .catch(err => {
                console.log(err)
            });
        },
        send(){
            if(this.isupd){
                this.upd()
            }else{
                this.add()
            }
        },
        add(){
            apiAdd(
                this.getdata()
            )
            .then(res => {
                EventBus.$emit('list-refresh');
                this.res_success()
            })
            .catch(err => {
                console.log(err)
            });
        },
        setdata(data){
            this.id = data.id
            this.acc = data.account,
            this.name = data.name,
            this.email= data.email,
            this.role= data.role
            this.status= data.status_type
            this.com= data.com
        },
        upd(){
            apiUpd(
                this.getdata()
            )
            .then(res => {
                EventBus.$emit('list-refresh');
                this.res_success()
            })
            .catch(err => {
                console.log(err)
            });
        },
        res_success(){
            this.reset()
            this.toast('操作成功', 'success')
            this.close()
        },
        reset(){
            this.$refs.form_val.reset();
            this.acc = ''
            this.pwd = ''
            this.name = ''
            this.email = ''
            this.role = 1
            this.status = 0
            this.com = 1
            $(document).ready(function() {
                $('.duallistbox option').prop('selected', false);
                $('.duallistbox').bootstrapDualListbox('refresh');
            })
        },
        toast(){
            this.swal().mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            }).fire({
                icon: 'success',
                title: '操作成功'
            })
        }
    }
}
</script>